(function () {
    'use strict';

    angular.module("imApp").factory("deliveryMethodLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listDeliveryMethodLanguages: function (parms) {
                return $ihttp.post({
                    method: 2175,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 2176,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
